document.addEventListener('click', (e) => {
  const tab = e.target.closest('.info-tab');
  if (!tab) return;

  const container = tab.closest('.info-tabs');
  const id = tab.dataset.tab;

  container.querySelectorAll('.info-tab').forEach(t => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });

  container.querySelectorAll('.info-tab-panel').forEach(p => {
    p.classList.remove('active');
  });

  tab.classList.add('active');
  tab.setAttribute('aria-selected', 'true');
  container.querySelector('#' + id).classList.add('active');
});
